module.exports = __webpack_public_path__ + "img/password-bg.74249295.png";